import { isMobile } from '@vindr/utils/mobile';

function isGEReformattedKeyImage(SeriesDescription) {
  return SeriesDescription?.includes('Key images reformatted');
}

export default function needJPEGImages(instance) {
  const isOutOfMaxTextureSize =
    isMobile() && (instance.Columns > 4096 || instance.Rows > 4096);
  const NEED_JPEG_MODALITIES = window?.config?.needJpegModalities || ['US'];

  const isGESnapshot = instance.Modality === 'OT' && instance.SeriesDescription?.includes('Snapshot');

  return (
    NEED_JPEG_MODALITIES.includes(instance.Modality) ||
    isGEReformattedKeyImage(instance.SeriesDescription) ||
    isOutOfMaxTextureSize ||
    isGESnapshot
  );
}
